import { PanInfo, TapInfo } from 'framer-motion'
import { createContext, useContext } from 'react'

interface DragHandlers {
  onPan: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void
  onPanEnd: (event: MouseEvent | TouchEvent | PointerEvent, info: PanInfo) => void
  onTap?: (event: MouseEvent | TouchEvent | PointerEvent, info: TapInfo) => void
}

const DragContext = createContext<DragHandlers | null>(null)

export const useBottomSheetDrag = () => useContext(DragContext)

export const DragProvider = DragContext.Provider
